exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".enrollments-grid-container{max-width:100%;overflow-x:clip}.enrollments-grid-container>*{max-width:100%}@media (max-width:640px){.enrollments-grid-container .enrollments-grid-toolbar-right{flex-direction:column!important;align-items:stretch!important;width:100%!important}.enrollments-grid-container .enrollments-grid-toolbar-right>div{width:100%}.enrollments-grid-container he-search-box{width:100%!important;min-width:0!important;display:block}.enrollments-grid-container he-dropdown{min-width:0}}", ""]);

// exports
